import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Authorize from "../../routes/authorize";
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import {useState} from "react";
import {Typography} from '@mui/material';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
    block: {
        position: 'fixed',
        left: '0',
        top: '0',
        width: '100%',
    },
    menu: {
        height: '80px'
    }
});

export default function NavigationAppBar({handleChange, logout}) {
    const classes = useStyles();
    const anchor = 'left'
    const [open, setOpen] = useState(false)

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(!open)
    };


    const list = (anchor) => (
        <Box
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            <List>
                {Authorize.filter((obj) => obj.label).map((obj, index) => {
                    return (
                        <ListItem key={index} disablePadding
                                  onClick={(event) => {
                                      handleChange(index);
                                  }}
                        >
                            <ListItemButton>
                                <ListItemIcon>
                                    {React.createElement(obj.icon, {})}
                                </ListItemIcon>
                                <ListItemText primary={obj.label} />
                            </ListItemButton>
                        </ListItem>)
                })}
            </List>
        </Box>
    );

    return (
        <Box sx={{ flexGrow: 1 }} className={classes.menu}>
            <Box className={classes.block}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={toggleDrawer(open)}
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}></Typography>
                        <Button color="inherit" onClick={logout}>Logout</Button>
                    </Toolbar>
                </AppBar>
                <React.Fragment key={anchor}>
                    <Drawer
                        anchor={anchor}
                        open={open}
                        onClose={toggleDrawer(open)}
                    >
                        {list(anchor)}
                    </Drawer>
                </React.Fragment>
            </Box>
        </Box>
    );
}